<template>
  <div class="sypage">
    <div class="ent-block">
      <!-- ，{{greetings}}{{nowTimeStr}} -->
      <span><i>欢迎使用信用服务平台！尊敬的{{ entName }}管理员.</i></span>
      <span>
        <!-- <img :src="clickgif" alt=""> -->
        <!--   </span> -->
       <a><span @click="toPath('/creditService')"><i class="el-icon-s-home"></i> 首页</span></a>
        <el-divider direction="vertical"></el-divider>
        <a><span @click="toPath('/UserInfo')"><i class="el-icon-user-solid"></i> 个人中心</span></a>
        <el-divider direction="vertical"></el-divider>
        <span @click="Logoff"><i class="el-icon-s-unfold"></i> 退出</span>
      </span>
    </div>
    <div class="Api-block">
      <img :src="blackCatLogo" alt="blackCatLogo" class="logoImg-class" />
      <div class="text-top" @click="toPath('/PrimarySurface')">
        <p class="text-cn"><span data-title="您好,管理员!" data-intro="这是您首次进入中国航空油料集团有限公司信用服务平台,接下来跟着我的指引,告诉您如何使用平台常用功能!" data-step="1">中国航空油料集团有限公司信用服务平台</span></p>
        <p class="text-en">
          <span>Black Cat electronic bidding procurement transaction credit service platform</span>
        </p>
      </div>
      <div class="Api-Menu" v-if="false">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
          <el-submenu index="1">
            <template slot="title"><span>常用服务</span></template>
            <div class="button-common-use">
              <div class="common-use-row">
                <div class="common-use-column" @click="toPath('/ReportInfo?reportType=v1')">
                  <icon-folder theme="multi-color" size="50" :fill="['#FFF' ,'#2F88FF' ,'#FFF' ,'#43CCF8']" />
                  <div class="common-use-column-text">
                    <p class="text-cn">供应商准入</p>
                    <p class="text-en">SupplierAccess</p>
                  </div>
                </div>
                <div class="common-use-column" @click="toPath('/ReportInfo?reportType=v2')">
                  <icon-folder theme="multi-color" size="50" :fill="['#FFF' ,'#ff42bd' ,'#FFF' ,'#ff00ff']" />
                  <div class="common-use-column-text">
                    <p class="text-cn">信用评价报告</p>
                    <p class="text-en">CreditEvaluation</p>
                  </div>
                </div>
                <div class="common-use-column" @click="toPath('/electronicGuarantee')">
                  <icon-folder theme="multi-color" size="50" :fill="['#FFF' ,'#2F88FF' ,'#FFF' ,'#43CCF8']" />
                  <div class="common-use-column-text">
                    <p class="text-cn">投标电子保函</p>
                    <p class="text-en">BidGuarantee</p>
                  </div>
                </div>
              </div>
              <div class="common-use-row">
                <div class="common-use-column" @click="toPath('/electronicGuarantee')">
                  <icon-folder theme="multi-color" size="50" :fill="['#FFF' ,'#33d857' ,'#FFF' ,'#31d054']" />
                  <div class="common-use-column-text">
                    <p class="text-cn">履约电子保函</p>
                    <p class="text-en">performanceSecurity</p>
                  </div>
                </div>
                <div class="common-use-column" @click="toPath('/financingDemand')">
                  <icon-folder theme="multi-color" size="50" :fill="['#FFF' ,'#2F88FF' ,'#FFF' ,'#43CCF8']" />
                  <div class="common-use-column-text">
                    <p class="text-cn">融资需求发布</p>
                    <p class="text-en">FinancingNeeds</p>
                  </div>
                </div>
                <div class="common-use-column" @click="toPath('/myOrder')">
                  <icon-folder theme="multi-color" size="50" :fill="['#FFF' ,'#ffaa00' ,'#FFF' ,'#ffaa7f']" />
                  <div class="common-use-column-text">
                    <p class="text-cn">发票服务</p>
                    <p class="text-en">InvoiceService</p>
                  </div>
                </div>
              </div>
            </div>
          </el-submenu>
          <el-submenu v-for="item in menu" :index="item.index" :key="item.index" v-if="item.children && item.children.length>0">
            <template slot="title"><span @click="clickMenu(item)">{{ item.label }}</span></template>
            <el-menu-item v-for="childrenItem in item.children" :index="childrenItem.index" :key="childrenItem.index" @click="clickMenu(childrenItem)">
              {{ childrenItem.label }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="5" @click="toPath('/UserInfo')"><span>个人中心</span></el-menu-item>
          <el-menu-item index="6" @click="toPath('/hmqA')"><span>帮助中心</span></el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken } from "@/utils/auth";
import { loginout } from "@/api/login";
import blackCatLogo from "@/assets/img/logo.png";
import clickgif from "@/assets/img/banner/click.gif";
import { Home } from "@icon-park/vue";
export default {
  name: "Head",
  components: { Home },
  data() {
    return {
      blurEvent: false,
      openEvent: false,
      entName: "",
      nickName: "",
      blackCatLogo: blackCatLogo,
      clickgif: clickgif,
      phonenumber: "",
      greetings: "您好！",
      nowTimeStr: "",
      activeIndex: "1",
      menu: [
        {
          index: "2",
          path: "/creditService",
          name: "/",
          label: "信用服务",
          icon: "s-platform",
          children: [
            {
              index: "2-1",
              path: "/ReportInfo?reportType=v1",
              name: "SupplierAccesslist",
              label: "供应商准入报告",
            },
            {
              index: "2-2",
              path: "/ReportInfo?reportType=v2",
              name: "PayJudgment",
              label: "企业信用评价",
            },
            {
              index: "2-7",
              path: "/ReportInfo?reportType=v7",
              name: "creditEvaluationOfBiddingAgency",
              label: "招标代理行业信用评价",
            },
            {
              index: "2-3",
              path: "/ReportInfo?reportType=v3",
              name: "enterpriseBasicCreditReport",
              label: "企业基础信用报告",
            },
            {
              index: "2-5",
              path: "/ReportInfo?reportType=v4",
              name: "businessRiskScreeningReport",
              label: "企业经营风险筛查报告",
            },
            {
              index: "2-6",
              path: "/ReportInfo?reportType=v5",
              name: "smeAssistanceLoanAnalysisReport",
              label: "中小企业助贷分析报告",
            },
          ],
        },
        {
          index: "3",
          path: "/electronicGuarantee",
          name: "",
          label: "电子保函",
          icon: "s-finance",
          children: [
            {
              index: "3-1",
              path: "/electronicGuarantee",
              name: "electronicGuarantee",
              label: "电子保函",
            },
            {
              index: "3-2",
              path: "/electronicGuaranRecord",
              name: "electronicGuaranRecord",
              label: "保函申请记录",
            },
          ],
        },
        {
          index: "4",
          path: "/financialProducts",
          name: "",
          label: "金融服务",
          icon: "s-finance",
          children: [
            // {
            //   index: "4-1",
            //   path: "/financialProducts",
            //   name: "financialProducts",
            //   label: "金融产品1",
            // },
            // {
            //   index: "4-2",
            //   path: "/financingDemand",
            //   name: "financingDemand",
            //   label: "融资需求",
            // },
            {
              index: "4-3",
              path: "/ProductCenters",
              name: "ProductCenters",
              label: "金融产品",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.userInfo();
    var _this = this;
    // var now = new Date(),hour = now.getHours();
    // if(hour < 6){this.greetings = "凌晨好！"}
    // else if (hour < 9){this.greetings ="早上好！"}
    // else if (hour < 12){this.greetings ="上午好！"}
    // else if (hour < 14){this.greetings ="中午好！"}
    // else if (hour < 17){this.greetings ="下午好！"}
    // else if (hour < 19){this.greetings ="傍晚好！"}
    // else if (hour < 22){this.greetings ="晚上好！"}
    // else {this.greetings = "很晚了！请注意休息。"}
    // this.timer=setInterval(function(){
    //     _this.showNowTime();
    // },1000);
    // const intro = this.$intro();
    // intro.setOptions({
    //   nextLabel: "下一步", // 下一个的按钮文字
    //   prevLabel: "上一步", // 上一个按钮文字
    //   skipLabel: "x", // 跳过指引的按钮文字
    //   doneLabel: "完成", // 完成按钮的文字
    //   hidePrev: false, // 是否在第一步中隐藏“上一步”按钮;不隐藏，将呈现为一个禁用的按钮
    //   hideNext: false, // 是否在最后一步中隐藏“下一步”按钮（同时会隐藏完成按钮);不隐藏，将呈现为一个禁用的按钮
    //   exitOnEsc: false, // 点击键盘的ESC按钮是否退出指引
    //   exitOnOverlayClick: false, // 点击遮罩层时是否退出介绍
    //   showStepNumbers: false, // 是否显示步骤编号
    //   disableInteraction: true, // 是否禁用高亮显示框内元素的交互
    //   showBullets: true, // 是否显示面板的指示点
    //   overlayOpacity: 0.7, // 遮罩层的透明度 0-1之间
    //   helperElementPadding: 10, // 选中的指引元素周围的填充距离
    // });
    // // console.dir(intro)
    // // this.$nextTick(() => {
    // //   this.$intro().start()
    // // })

    // this.$nextTick(() => {
    //   if (localStorage.getItem("isFirst") === null || localStorage.getItem("isFirst") !== "1") {
    //     intro.start();
    //     localStorage.setItem("isFirst", 1);
    //   }
    // });
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    showNowTime() {
      var now = new Date();
      this.nowTimeStr =
        "现在时间是 " +
        now.getFullYear() +
        "年" +
        (now.getMonth() + 1) +
        "月" +
        now.getDate() +
        "日" +
        now.getHours() +
        "时" +
        now.getMinutes() +
        "分" +
        now.getSeconds() +
        "秒";
    },
    logos() {
      this.$router.push("/PrimarySurface");
    },
    logoslist() {
      this.$router.push("/InFormaTionDisplay");
    },
    clickMenu(item) {
      console.dir(item);
      this.$router.push({ path: item.path });
    },
    userInfo() {
      this.$get("/getInfo").then(
        (res) => {
          if (res.data.code === 200) {
            this.entName = res.data.userCompany.entName;
            this.nickName = res.data.user.nickName;
            this.phonenumber = res.data.user.phonenumber;
            sessionStorage.setItem("getinfo", JSON.stringify(res.data.userCompany));
            sessionStorage.setItem("user", JSON.stringify(res.data.user));
          }
        },
        (error) => {}
      );
    },
    Logoff() {
      loginout().then((res) => {
        if (res.data.code != 200) {
          return this.$message.error(res.data.msg);
        } else {
          removeToken();
          sessionStorage.clear();
          this.$message.success(res.data.msg);
          this.$router.push("/Login");
          // this.GeUerse();
          // this.isloag = true;
          // this.islouser = false;
        }
      });
    },
    heicats() {
      this.$router.push({
        path: "/PrimarySurface",
      });
    },
    toPath(pathStr) {
      this.$router.push({
        path: pathStr,
      });
    },
  },
};
</script>
<style scoped>
.el-menu.el-menu--horizontal {
  border-bottom: solid 0px #e6e6e6;
}
.Api-Menu {
  margin-left: 130px;
}
.text-en {
  font-size: 10px;
  text-align: left;
}
.text-cn {
  font-size: 15px;
  font-weight: bold;
  text-align: left;
}
.common-use-row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 25px;
}
.common-use-column:hover {
  border: 1px solid #2a91ff;
}
.common-use-column-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.common-use-column {
  width: 170px;
  height: 60px;
  background-color: #f5f7f9;
  border-radius: 5px;
  border: 1px solid #fff;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.button-common-use {
  width: 650px;
  background-color: #fff;
  cursor: pointer;
}
.logoImg-class {
  margin-left: 20px;
  /* width: 150px; */
}
.ent-block {
  background-image: linear-gradient(to left, #2a91ff, #3d7bb9, #2a91ff);
  height: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.ent-block span {
  display: block;
  /* width: 80%; */
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
}
.ent-Menu {
  font-size: 15px;
  color: #383635;
}
.ent-Menu span {
  display: block;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Api-block {
  display: flex;
  align-items: center;
  width: 100%;
}
.Api-Menu span {
  font-size: 0.875rem;
  font-weight: bold;
  color: #343a40;
}
.header-nav-wrapper {
  /* line-height: 75px; */
  float: right;
  margin: 0;
}
.header-nav-wrapper > li {
  float: left;
  margin: 0px 20px;
  cursor: pointer;
  position: relative;
  height: 74px;
  display: flex;
  align-items: center;
}
.header-nav-wrapper > li.active > a {
  color: #ffaa7f;
  text-decoration: none;
  border-bottom: 2px solid #ffaa7f;
}
.header-nav-wrapper > li > a:hover {
  color: #ffbb93;
  text-decoration: none;
}
.header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
.header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
.header-nav-wrapper > li > a {
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
.header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #ffaa7f;
}

.sypage {
  display: flex;
  align-items: center;
  flex-direction: column;
  z-index: 99;
}

.text-top {
  color: #000;
  cursor: pointer;
}
.text-top .text-cn {
  font-size: 18px;
  font-weight: bold;
  /* width: 600px; */
  /* text-align: left; */
}
.text-top .text-en {
  font-size: 10px;
  /* font-weight: 700;
  width: 600px;
  text-align: left; */
}
.rightText {
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  width: 30%;
  font-weight: 700;
  flex: 2;
  /* margin-left: 30%; */
  float: right;
  text-align: right;
}
.el-button {
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}
.ent-block span:nth-child(2) {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* background-image: url("../../../assets/img/banner/click.gif");
  background-position: bottom;
  background-size: 40%;
  background-repeat: no-repeat; */
  color: #fff;
  font-weight: bold;
  height: 100px;
}
.ent-block span:nth-child(2) img {
  width: 30px;
}
.ent-block a {
  text-decoration: none;
  color: #fff;
}
.a-rext {
  color: #fff;

  font-size: 96px;

  /* 字间距 */

  letter-spacing: 15px;

  /* 转大写 */

  text-transform: uppercase;

  text-align: center;

  line-height: 76px;

  outline: none;

  /* 自定义属性--c，可通过var函数对其调用 */

  --c: lightseagreen;

  /* 调用自定义属性--c，设置文字阴影（发光效果） */

  text-shadow: 0 0 10px var(--c), 0 0 20px var(--c), 0 0 40px var(--c), 0 0 80px var(--c),
    0 0 160px var(--c);

  /* 执行动画：动画名 时长 线性的 无限次播放 */

  animation: animate 5s linear infinite;
}

/* 定义动画 */

@keyframes animate {
  to {
    /* 色相旋转滤镜（设置度数可改变颜色） */

    filter: hue-rotate(360deg);
  }
}
/* logo.png */
</style>



// WEBPACK FOOTER //
// src/views/Layout/components/Head.vue